import { render, staticRenderFns } from "./NormalInput.vue?vue&type=template&id=3cc6d889&scoped=true"
import script from "./NormalInput.vue?vue&type=script&lang=js"
export * from "./NormalInput.vue?vue&type=script&lang=js"
import style0 from "./NormalInput.vue?vue&type=style&index=0&id=3cc6d889&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6d889",
  null
  
)

export default component.exports